/**
 * safe-url.ts — vbsec L42.
 *
 * Nhiều nơi vẽ `<a href={...}>`/`<img src={...}>` bấm được từ nội dung khách hàng/kênh (link trong tin
 * nhắn Zalo, link sản phẩm thương mại điện tử, trường tuỳ biến dạng "url" của khách hàng). Nếu dữ liệu
 * đó chứa `javascript:`/`data:` thay vì http(s), bấm vào chạy thẳng mã trong trang (XSS) — trình duyệt
 * không tự chặn vì đây không phải nội dung nhúng, mà là điều hướng do người dùng bấm.
 *
 * Dùng hàm này ở MỌI chỗ href/src lấy từ dữ liệu không phải do mình tạo ra (property của hệ thống,
 * ảnh/âm thanh do chính server sinh ra, không cần qua đây).
 */
export function safeHttpUrl(value: string | null | undefined): string | undefined {
  if (!value) return undefined
  const trimmed = value.trim()
  if (!trimmed) return undefined

  // Chuỗi không có scheme rõ ràng: nếu là domain trần ("app.ecdp.vn", link dán vào tin nhắn không gõ
  // "https://") thì `new URL(value, base)` coi nó là đường dẫn TƯƠNG ĐỐI và trả nguyên văn `value` —
  // gắn thẳng vào href sẽ bị trình duyệt phân giải theo TRANG HIỆN TẠI (bấm vào "app.ecdp.vn" trong tin
  // nhắn lại nhảy sang route nội bộ của SPA thay vì mở trang ngoài — lỗi báo 18/10/2026). Phải tự thêm
  // scheme cho các chuỗi này trước khi coi là an toàn, chỉ giữ nguyên dạng tương đối cho ĐÚNG đường dẫn
  // gốc một gạch chéo (`/media/...`, do chính hệ thống sinh ra) — KHÔNG nhận dạng tương đối hai gạch
  // chéo (`//evil.com`, "protocol-relative" — trình duyệt tự suy ra http/https theo trang hiện tại, một
  // kiểu mở site ngoài trá hình vẫn lọt qua kiểm tra protocol cũ).
  const hasScheme = /^[a-z][a-z0-9+.-]*:/i.test(trimmed)
  const isRootRelative = trimmed.startsWith('/') && !trimmed.startsWith('//')
  const candidate = hasScheme || isRootRelative
    ? trimmed
    : trimmed.startsWith('//') ? `https:${trimmed}` : `https://${trimmed}`

  try {
    // Base giả định chỉ để `new URL()` phân giải được đường dẫn tương đối (`/media/...`) — không
    // dùng `window.location.origin` vì hàm này cũng chạy trong test (môi trường không có `window`).
    const u = new URL(candidate, 'http://localhost')
    return u.protocol === 'http:' || u.protocol === 'https:' ? candidate : undefined
  } catch {
    return undefined
  }
}
